import * as React from 'react';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { SimpleFormComponentProps, SimpleFormMethods } from 'app/infrastructure/simple-form/types';
import { SelectSingle } from 'app/area/shared/translated-components';

export const selectSingleCreator = (props: SimpleFormComponentProps, fieldMethods: SimpleFormMethods, fieldState?: any) =>
  <SelectSingle
    onChange={fieldMethods.handleChange(props.name)}
    componentId={props.name}
    className={props.className}
    label={fieldMethods.buildLabel(props.label)}
    validation={fieldMethods.getValidation(props.name)}
    valueItem={fieldMethods.getProperty(props.name) || []}
    options={fieldMethods.getOptions(props.name)}
    categoryOptions={fieldMethods.getCategoryOptions(props.name)}
    placeholder={props.placeholder}
    onLoadOptions={fieldMethods.onLoadOptions(props.name, props.optionsEndpoint, props.optionsParams)}
    loadOptions={fieldState.loadedOptions[props.name]}
    loadCategoryOptions={fieldState.loadedCategoryOptions[props.name]}
    isOpen={props.hasFocus}
    ref={fieldMethods.createRefToScrollableComponent(props.name)}
    fetching={fieldMethods.isFetching(props.name)}
    readOnly={props.readOnly}
    optionsDisplaySetting={isDefinedIncludingZero(props.optionsDisplaySetting)
      ? { type: props.optionsDisplaySetting }
      : undefined}
    initiallyShowLongDescription={props.initiallyShowLongDescription}
    showIcons={false}
    alwaysOpen={props.alwaysOpen}
    searchRequired={props.searchRequired}
    resetPreviousValueWhenEmpty={props.resetPreviousValueWhenEmpty}
    categoryId={props.categoryId}
    showIndexWhenNoOfPagesIsAbove={props.showIndexWhenNoOfPagesIsAbove}
    extraFooterButton={props.extraFooterButton}
    displayCategories={props.displayCategories}
    onLoadCategoryOptions={fieldMethods.onLoadCategoryOptions(props.name, props.categoryOptionsEndpoint, props.categoryOptionsParams)}
    meatballPanelConfiguration={props.meatballPanelConfiguration}
  />;
